var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 47,
    viewBox: "0 0 27 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85654 47C2.86959 47 1.88217 46.6175 1.13002 45.8526C-0.376674 44.3228 -0.376674 41.8444 1.13002 40.3146L17.694 23.5015L1.13002 6.68544C-0.376674 5.15559 -0.376674 2.67723 1.13002 1.14739C2.63672 -0.382462 5.07757 -0.382462 6.58426 1.14739L25.87 20.7294C27.3767 22.2593 27.3767 24.7376 25.87 26.2675L6.58426 45.8496C5.83091 46.6206 4.84373 47 3.85654 47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageRightArrow);
export default __webpack_public_path__ + "static/media/HomePage_rightArrow.1ff66e9247b7d561f690a0e86fd53e37.svg";
export { ForwardRef as ReactComponent };